import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center h-full min-h-[300px]"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-textSecondary" }, "Não foi possível carregar os detalhes do pedido.", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-lg" }, "Resumo do pedido")
], -1)
const _hoisted_8 = { class: "flex flex-col gap-y-2 pb-2" }
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mt-2" }
const _hoisted_10 = { class: "flex flex-col text-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Data da solicitação", -1)
const _hoisted_12 = { class: "text-base text-secondary" }
const _hoisted_13 = { class: "flex flex-col text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Solicitante", -1)
const _hoisted_15 = { class: "text-base text-secondary" }
const _hoisted_16 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mt-2" }
const _hoisted_17 = { class: "flex flex-col text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Data da aprovação", -1)
const _hoisted_19 = { class: "text-base text-secondary" }
const _hoisted_20 = { class: "flex flex-col text-left" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Aprovadores", -1)
const _hoisted_22 = { class: "text-base text-secondary" }
const _hoisted_23 = {
  key: 1,
  class: "flex flex-col gap-y-2 pb-2"
}
const _hoisted_24 = { class: "flex flex-col text-left" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Status", -1)
const _hoisted_26 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mt-2" }
const _hoisted_27 = { class: "flex flex-col text-left" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Data da solicitação", -1)
const _hoisted_29 = { class: "text-base text-secondary" }
const _hoisted_30 = { class: "flex flex-col text-left" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Solicitante", -1)
const _hoisted_32 = { class: "text-base text-secondary" }
const _hoisted_33 = { class: "flex flex-col text-left" }
const _hoisted_34 = { class: "text-secondary font-bold text-base" }
const _hoisted_35 = { class: "text-base text-secondary" }
const _hoisted_36 = { class: "flex flex-col text-left" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Aprovador", -1)
const _hoisted_38 = { class: "text-base text-secondary" }
const _hoisted_39 = {
  key: 1,
  class: "flex flex-col items-start gap-2"
}
const _hoisted_40 = { class: "text-2xl font-bold text-textPrimary mb-4 text-left" }
const _hoisted_41 = { class: "text-secondary text-base text-left" }
const _hoisted_42 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 pb-2 mt-2"
}
const _hoisted_43 = { class: "flex flex-col text-left" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Data da solicitação", -1)
const _hoisted_45 = { class: "text-base text-secondary" }
const _hoisted_46 = { class: "flex flex-col text-left" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Solicitante", -1)
const _hoisted_48 = { class: "text-base text-secondary" }
const _hoisted_49 = {
  key: 0,
  class: "flex flex-col text-left"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Data da aprovação", -1)
const _hoisted_51 = { class: "text-base text-secondary" }
const _hoisted_52 = {
  key: 1,
  class: "flex flex-col text-left"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "text-secondary font-bold text-base" }, "Aprovador", -1)
const _hoisted_54 = { class: "text-base text-secondary" }
const _hoisted_55 = {
  key: 0,
  class: "flex items-start gap-2 px-3 py-2 mt-6 rounded-md border border-primary30 bg-primary5 text-sm text-textPrimary text-left",
  "data-testid": "summary-exception-post-station-lock-banner"
}
const _hoisted_56 = {
  key: 1,
  class: "flex flex-row gap-4"
}
const _hoisted_57 = {
  key: 0,
  class: "w-full flex flex-row gap-8 mt-6"
}
const _hoisted_58 = {
  key: 1,
  class: "w-full mt-6"
}
const _hoisted_59 = {
  key: 2,
  class: "flex justify-around gap-8 mt-6"
}

import { ref, computed, watch } from 'vue'
import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import ExceptionSimpleCard from '../Cards/ExceptionSimpleCard.vue'
import ExceptionWorkingDayCard from '../Cards/ExceptionWorkingDayCard.vue'
import StatusBadge from '../Badges/StatusBadge.vue'
import TextareaInput from '../Textarea/TextareaInput.vue'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import ExceptionService from '@/Network/Services/DoctorStationException'
import { formatDateToString, formatDateTimeWithTimezone } from '@/utils/date'
import { formatRepassMode, formatProportionalityRule } from '@/utils/formatters'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

import {
  ExceptionActionType,
  ExceptionStatusEnum,
  type ExceptionSummary
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import ExceptionAgreedValueCard from '../Cards/ExceptionAgreedValueCard.vue'
import StationContextCard from '../Cards/StationContextCard.vue'
import ExceptionalityProgressTimeline from '@/modules/company/Approvals/AuditoriumExceptionalities/components/ExceptionalityProgressTimeline.vue'
import { mapApprovalToTimeline } from '@/utils/approval-timeline-mapper'
import { mdiLock } from '@mdi/js'
import SVGIcon from '@/components/SVGIcon.vue'
import { POST_STATION_LOCK_BANNER_TEXT } from '@/modules/company/PostStation/constants'
import {
  getPostStationApprovedMessage,
  isPostStationApprovedError
} from '@/modules/company/PostStation/errors'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

interface StationContextData {
  doctorName: string
  doctorCrm?: string
  scheduleName: string
  positionName: string
  shiftName?: string
  team?: string
  timeRange: string
  dutyType?: string
  value?: string
  formation?: string
  repassMode?: string
  proportionalityRule?: string
  breadcrumb?: string
  allocatedBy?: string
  startDetail?: string
  endDetail?: string
  timezone?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryExceptionalitySidebar',
  props: {
    isOpen: { type: Boolean },
    exceptionId: {},
    scheduleId: {},
    actionType: {},
    stationContext: {},
    postStationLocked: { type: Boolean, default: false }
  },
  emits: ["update:isOpen", "actionCompleted", "detailsLoaded"],
  setup(__props: any, { emit }) {

const props = __props;

const toast = useToast()
const { notifyError } = useErrorToast()
const exceptionService = new ExceptionService()
const permissionsStore = usePermissionsStore()
const { flags } = useFeatureFlags()





const canCancelException = computed(() => {
  if (!props.scheduleId) return false
  return permissionsStore.check({
    permission: AuthorizationPermissions.StationExceptionalitiesCancelling,
    resource: {
      objectType: AuthorizationResourcesAndSubjects.Schedule,
      objectId: props.scheduleId
    }
  })
})

const canRevertException = computed(() => {
  if (!props.scheduleId) return false
  return permissionsStore.check({
    permission: AuthorizationPermissions.StationExceptionalitiesReverting,
    resource: {
      objectType: AuthorizationResourcesAndSubjects.Schedule,
      objectId: props.scheduleId
    }
  })
})

const isConfirming = ref(false)
const loading = ref(false)
const actionLoading = ref(false)
const reversalJustification = ref('')
const detailedException = ref<ExceptionSummary | null>(null)

const timelineProps = computed(() => {
  const instance = detailedException.value?.approvalInstance
  if (!instance) return null
  return mapApprovalToTimeline({
    approvalInstance: instance,
    requestDate: detailedException.value!.requestDate,
    requesterName: detailedException.value!.requester.name
  })
})

const approvedApproversText = computed(() => {
  const decisions = detailedException.value?.approvalInstance?.decisions
  if (!decisions) return ''
  return decisions
    .filter((d) => d.decision === 'APPROVED' && d.userName)
    .map((d) => d.userName)
    .join(', ')
})

const evaluationDateLabel = computed(() => {
  const status = detailedException.value?.status
  if (status === ExceptionStatusEnum.APPROVED) return 'Data da aprovação'
  if (status === ExceptionStatusEnum.REJECTED) return 'Data da reprovação'
  return 'Data da avaliação'
})

const evaluationDateDisplay = computed(() => {
  if (!detailedException.value) return null
  const date = detailedException.value.approvalDate ?? detailedException.value.evaluationDate
  return date ? formatDateToString(new Date(date)) : null
})

const evaluatorOrApproverName = computed(() => {
  return (
    detailedException.value?.evaluator?.name || detailedException.value?.approver?.name || 'N/A'
  )
})

const modelValue = computed({
  get: () => props.isOpen,
  set: (value) => {
    if (!value) {
      isConfirming.value = false
      reversalJustification.value = ''
      detailedException.value = null
      loading.value = false
      actionLoading.value = false
    }
    emit('update:isOpen', value)
  }
})

const headerId = computed(() => {
  return `<span class="inline-block bg-white py-2 px-1 rounded-lg text-2xl">#${props.exceptionId?.toString().padStart(5, '0') || 'N/A'}</span>`
})

watch(
  [() => props.isOpen, () => props.exceptionId],
  async ([newIsOpen, newExceptionId]) => {
    if (!newIsOpen || newExceptionId === null) {
      detailedException.value = null
      return
    }

    if (detailedException.value?.id === newExceptionId) {
      return
    }

    loading.value = true
    try {
      const details = await exceptionService.getDetails(newExceptionId)
      detailedException.value = details
      emit('detailsLoaded', details)
    } catch (error) {
      console.error('Falha ao buscar detalhes da excepcionalidade:', error)
      detailedException.value = null
      notifyError(error, 'Não foi possível carregar os detalhes do pedido')
    } finally {
      loading.value = false
    }
  },
  { immediate: true }
)

const confirmationTitle = computed(() => {
  if (props.actionType === ExceptionActionType.CANCEL) {
    return 'Tem certeza que deseja cancelar esse pedido?'
  } else if (props.actionType === ExceptionActionType.REVERT) {
    return 'Tem certeza que deseja reverter essa aprovação?'
  }
  return 'Confirmação'
})

const confirmationMessage = computed(() => {
  const actionText =
    props.actionType === ExceptionActionType.CANCEL
      ? 'cancelar o pedido'
      : 'reverter a aprovação do pedido'
  return `Deseja ${actionText} #${detailedException.value?.id || props.exceptionId}? Essa ação não poderá ser desfeita.`
})

function startConfirmation() {
  isConfirming.value = true
}

function cancelConfirmation() {
  isConfirming.value = false
  reversalJustification.value = ''
}

function closeSidebar() {
  modelValue.value = false
}

// Verbo das mensagens de erro/log da ação em curso.
const actionVerb = computed(() =>
  props.actionType === ExceptionActionType.CANCEL ? 'cancelar' : 'reverter'
)

// Executa o endpoint da ação confirmada. `VIEW` não tem ação: cai fora sem
// chamar nada (mesma semântica do `if/else if` original).
async function executeAction(exceptionId: number) {
  if (props.actionType === ExceptionActionType.CANCEL) {
    await exceptionService.cancel(exceptionId, Number(props.scheduleId))
    toast.success('Solicitação cancelada com sucesso!')
  } else if (props.actionType === ExceptionActionType.REVERT) {
    await exceptionService.revert(exceptionId, reversalJustification.value, props.scheduleId || 0)
    toast.success('Reversão realizada com sucesso!')
  }
}

async function handleConfirmAction() {
  if (!detailedException.value) {
    toast.error('Detalhes do pedido não disponíveis.')
    return
  }

  if (props.actionType === ExceptionActionType.REVERT && !reversalJustification.value.trim()) {
    toast.error('Por favor, informe a justificativa da reversão.')
    return
  }

  actionLoading.value = true
  try {
    await executeAction(detailedException.value.id)
    emit('actionCompleted')
    // Só fecha na trilha de sucesso: em erro a sidebar fica aberta para o
    // usuário ler a mensagem e tentar de novo (o setter de `modelValue` faz a
    // limpeza de estado).
    modelValue.value = false
  } catch (error) {
    console.error(`Erro ao ${actionVerb.value} a solicitação:`, error)

    // Sem este ramo o erro é SOBRESCRITO por "Não foi possível cancelar/reverter
    // a solicitação. Tente novamente." — que manda o usuário repetir uma ação
    // que vai falhar de novo, em vez de dizer para reverter a validação.
    if (isPostStationApprovedError(error)) {
      toast.error(getPostStationApprovedMessage(error))
      return
    }

    // Antes: fallback estático que mandava "tentar novamente" mesmo quando o
    // backend explicava o motivo — a mensagem do ServiceError tem prioridade.
    notifyError(error, `Não foi possível ${actionVerb.value} a solicitação`)
  } finally {
    actionLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createBlock(BaseSidebar, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    title: "Pedido de excepcionalidade",
    description: "Revise o resumo do pedido de excepcionalidade e, se necessário, cancele ou reverta a solicitação.",
    headerChildren: headerId.value
  }, _createSlots({
    footer: _withCtx(() => [
      (!isConfirming.value && _ctx.postStationLocked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createVNode(SVGIcon, {
              path: _unref(mdiLock),
              class: "w-4 h-4 mt-0.5 shrink-0 text-primary30"
            }, null, 8, ["path"]),
            _createElementVNode("span", null, _toDisplayString(_unref(POST_STATION_LOCK_BANNER_TEXT)), 1)
          ]))
        : _createCommentVNode("", true),
      (!isConfirming.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            (_ctx.actionType === _unref(ExceptionActionType).CANCEL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createVNode(FilledButton, {
                    text: "Voltar",
                    width: "46%",
                    onClick: closeSidebar,
                    class: "!bg-primary30",
                    height: "48px"
                  }),
                  (canCancelException.value)
                    ? (_openBlock(), _createBlock(OutlinedButton, {
                        key: 0,
                        text: "Cancelar pedido",
                        width: "46%",
                        "data-testid": "cancel-exception-button",
                        disabled: _ctx.postStationLocked,
                        onClick: startConfirmation,
                        height: "48px",
                        class: "flex-grow !border-negative !text-negative !bg-white"
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.actionType === _unref(ExceptionActionType).REVERT)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  (canRevertException.value)
                    ? (_openBlock(), _createBlock(FilledButton, {
                        key: 0,
                        text: "Reverter aprovação",
                        width: "100%",
                        "data-testid": "revert-exception-button",
                        disabled: _ctx.postStationLocked,
                        onClick: startConfirmation,
                        class: "!bg-primary30",
                        height: "48px"
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _createVNode(FilledButton, {
              text: "Cancelar",
              width: "46%",
              onClick: cancelConfirmation,
              height: "48px",
              class: "!bg-primary30"
            }),
            _createVNode(OutlinedButton, {
              text: "Confirmar",
              width: "46%",
              onClick: handleConfirmAction,
              loading: actionLoading.value,
              height: "48px",
              class: "flex-grow !border-negative !text-negative !bg-white"
            }, null, 8, ["loading"])
          ]))
    ]),
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "64"
            })
          ]))
        : (!detailedException.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : (detailedException.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!isConfirming.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      (_unref(flags).enabledApprovalEngine && detailedException.value.approvalInstance)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (timelineProps.value)
                              ? (_openBlock(), _createBlock(ExceptionalityProgressTimeline, {
                                  key: 0,
                                  "header-status": timelineProps.value.headerStatus,
                                  title: timelineProps.value.title,
                                  layers: timelineProps.value.layers,
                                  "base-event": timelineProps.value.baseEvent,
                                  class: "mb-4",
                                  "data-testid": "summary-exceptionality-progress-timeline"
                                }, null, 8, ["header-status", "title", "layers", "base-event"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(StatusBadge, {
                                status: detailedException.value.status
                              }, null, 8, ["status"]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _hoisted_11,
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(formatDateTimeWithTimezone)(detailedException.value.requestDate)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(detailedException.value.requester?.name || 'N/A'), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _hoisted_18,
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(detailedException.value.approvalDate
                    ? _unref(formatDateTimeWithTimezone)(detailedException.value.approvalDate)
                    : 'Pendente'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _hoisted_21,
                                  _createElementVNode("span", _hoisted_22, _toDisplayString(approvedApproversText.value || 'Nenhum até o momento'), 1)
                                ])
                              ])
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createVNode(StatusBadge, {
                                status: detailedException.value.status
                              }, null, 8, ["status"])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(formatDateToString)(new Date(detailedException.value.requestDate))), 1)
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("span", _hoisted_32, _toDisplayString(detailedException.value.requester?.name || 'N/A'), 1)
                              ]),
                              (evaluationDateDisplay.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("span", _hoisted_34, _toDisplayString(evaluationDateLabel.value), 1),
                                      _createElementVNode("span", _hoisted_35, _toDisplayString(evaluationDateDisplay.value), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                      _hoisted_37,
                                      _createElementVNode("span", _hoisted_38, _toDisplayString(evaluatorOrApproverName.value), 1)
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])),
                      _createVNode(ExceptionSimpleCard, {
                        class: "mt-4",
                        title: `Modalidade de repasse`,
                        description: _unref(formatRepassMode)(detailedException.value.changes.repassMode?.requested)
                      }, null, 8, ["description"]),
                      _createVNode(ExceptionSimpleCard, {
                        class: "mt-4",
                        title: `Regras de proporcionalidade`,
                        description: 
            _unref(formatProportionalityRule)(detailedException.value.changes.proportionalityRule?.requested)
          
                      }, null, 8, ["description"]),
                      (
            detailedException.value.changes.workJourney?.requested?.startHour &&
            detailedException.value.changes.workJourney?.requested?.endHour
          )
                        ? (_openBlock(), _createBlock(ExceptionWorkingDayCard, {
                            key: 2,
                            class: "mt-4",
                            "start-time": new Date(detailedException.value.changes.workJourney.requested.startHour),
                            "end-time": new Date(detailedException.value.changes.workJourney.requested.endHour),
                            "lost-hours": detailedException.value.financials.lostHours,
                            "estimated-loss": Number(detailedException.value.financials.estimatedLossTotal)
                          }, null, 8, ["start-time", "end-time", "lost-hours", "estimated-loss"]))
                        : _createCommentVNode("", true),
                      _createVNode(ExceptionAgreedValueCard, {
                        class: "mt-4",
                        "original-hourly-value": Number(detailedException.value.changes.hourlyValue?.original || 0),
                        "exceptional-cost": Number(detailedException.value.changes.hourlyValue?.requested || 0),
                        "base-cost": Number(detailedException.value.financials.baseCost || 0),
                        "estimated-loss-total": Number(detailedException.value.financials.estimatedLossTotal || 0),
                        "base-duration": Number(detailedException.value.financials.baseDurationHours || 0),
                        "exceptional-duration": Number(detailedException.value.financials.exceptionalDurationHours || 0)
                      }, null, 8, ["original-hourly-value", "exceptional-cost", "base-cost", "estimated-loss-total", "base-duration", "exceptional-duration"]),
                      _createVNode(ExceptionSimpleCard, {
                        class: "mt-4",
                        title: "Justificativa",
                        description: detailedException.value.justification || 'Nenhuma justificativa fornecida.'
                      }, null, 8, ["description"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("h2", _hoisted_40, _toDisplayString(confirmationTitle.value), 1),
                      _createElementVNode("p", _hoisted_41, _toDisplayString(confirmationMessage.value), 1),
                      (_ctx.actionType === _unref(ExceptionActionType).REVERT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _hoisted_44,
                              _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(formatDateToString)(new Date(detailedException.value.requestDate))), 1)
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _hoisted_47,
                              _createElementVNode("span", _hoisted_48, _toDisplayString(detailedException.value.requester?.name || 'N/A'), 1)
                            ]),
                            (detailedException.value.approvalDate)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  _hoisted_50,
                                  _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(formatDateToString)(new Date(detailedException.value.approvalDate))), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (detailedException.value.approver?.name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _hoisted_53,
                                  _createElementVNode("span", _hoisted_54, _toDisplayString(detailedException.value.approver.name), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.actionType === _unref(ExceptionActionType).REVERT)
                        ? (_openBlock(), _createBlock(TextareaInput, {
                            key: 1,
                            modelValue: reversalJustification.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reversalJustification).value = $event)),
                            placeholder: "Digite a justificativa da reversão...",
                            class: "w-full mt-4"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.stationContext)
      ? {
          name: "contextHeader",
          fn: _withCtx(() => [
            _createVNode(StationContextCard, _normalizeProps(_guardReactiveProps(_ctx.stationContext)), null, 16)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "headerChildren"]))
}
}

})